import axios from "axios";
import toast from "react-hot-toast";
import Cookie from "js-cookie"
import { store } from "indexStore";

const refreshToken = async () => {
  try {
    const response = await axiosInstance.get("/renewal_access_token")
    var path = window.location.pathname.split('/');

    switch (path[1]) {
      case "employer_dashboard":
        //updating professional token in cookies
        Cookie.set("eToken", response.data.data.access_token, {
          secure: true,
          sameSite: 'strict',
          path: '/'
        })
        break;

      case "professional":
        //updating professional token in cookies
        Cookie.set("pToken", response.data.data.access_token, {
          secure: true,
          sameSite: 'strict',
          path: '/'
        })
        break;

      case "partner_dashboard":
        //updating professional token in cookies
        Cookie.set("prToken", response.data.data.access_token, {
          secure: true,
          sameSite: 'strict',
          path: '/'
        })
        break;

      case "super_admin":
        //updating professional token in cookies
        Cookie.set("saToken", response.data.data.access_token, {
          secure: true,
          sameSite: 'strict',
          path: '/'
        })
        break;
      default:
        break;
    }
  } catch (err) {
    console.log(err)
  }

};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.error_code === 0 || response.data.error_code === 200 || response.data.error_code === 201
      || response.data.error_code === 204 || response.data.error_code === 205 || response.data.error_code === 403) {
      switch (response.data.message) {
        case "Trial period":
        case "Job posted successfully":
        case "Details fetched successfully!":
        case "Your profile has been retrieved successfully!":
        case "Your profile has been updated successfully!":
        case "The job status has been updated successfully.":
        case "Candidate status has been updated successfully!":
        case "The job post has been updated successfully!":
        case "User details displayed successfully":
        case "Resume extracted successfully!":
        case "Professional Profile info fetched successfully":
        case "Flag updated successfully":
        case "Search results displayed successfully!":
        case "Job has been saved successfully!":
        case "Filtered list successfully!":
        case "Notification status updated successfully":
        case "Notification cleared successfully":
        case "Additional info inserted successfully":
        case "Your video has been uploaded successfully":
        case "Profile picture uploaded successfully":
        case "Resume deleted successfully":
        case "Questions fetched successfully":
        case "User account created successfully":
        case "Job unsaved":
        case "success!":
        case "Partner profile Not Found":
        case "No records found for this employer":
        case "Employer profile Not Found":
        case "Learning post Not Found":
        case "Record not found":
        case "Post not found":
        case "Job not found":
        case "Details fetched successfully":
        case "Your account has been created successfully. A verification link has been sent to your registered email. Please verify to proceed using the platform. If you don't see the email, please check your spam or junk folder.":
        case "Login successful!":
        case "No records found":
        case "No record found":
        case "No employer profile found":
        case "No jobs found!":
        case "No jobs found":
        case "No job posted":
        case "No profile matches":
        case "Status has been updated successfully.":
        case "We notice that you're currently not subscribed our product. Please choose a subscription plan suites for you":
        case "We notice that you're currently not subscribed our product. Please choose a subscription plan suites for you":
        case "token updated":
        case "success":
        case "Post has been created successfully!":
        case "Please upgrade your plan to continue posting new jobs.":
        case "Please upgrade your plan to continue posting new ads.":
        case "You have reached your job postings limit. Please upgrade your plan to post jobs.":
        case "Your trial period for posting jobs has expired. Please upgrade your plan to continue.":
        case "Post has been edited successfully!":
        case "Job invitation already sent":
        case "Jobs fetched successfully!":
        case "Please fill in all the required fields.":
        case "Sub-users not exists.":
        case "Sub-users details fetched successfully!":
        case "Success":
        case "Candidates detail fetched successfully.":
        case "It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile":
        case "Feedbacks fetched successfully":
        case "There are currently no applicants for this job. Please try again later.":
        case "Summary fetched successfully":
        case "Discourse login successfull":
          break;


        case "The job has been successfully closed. We would like to thank you for posting the job.":
        case "Job drafted":
        case "Applied for the job successfully!":
        case "Profile picture deleted successfully":
        case "Could not upload profile picture":
        case "Unsupported file format":
        case "No jobs have been posted by this company yet.":
        case "No applicants have applied for this job yet.":
        case "No jobs have been posted by the employer.":
        case "The job has been recommended to the professional!":
        case "We have a job recommendation for you. Click on the recommended tab to view the recommendation.":
        case "This job has already been recommended to the professional":
        case "The professional has been recommended for the job!":
        case "We have a profile recommendation for the job you posted":
        case "The professional has already been recommended for this job!":
        case "The professional has been removed from the recommendation!":
        case "Your draft has been saved successfully":
          toast.success(response.data.message);
          break;

        case "error: \n{\"message\":\"It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile\"}\n":
        case "error: {\"message\":\"It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile\"}":
          toast.error("It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile");

        default:
          toast.success(response.data.message);
          break;
      }
    } else {
      if (response.data.error_code !== 300) {
        if (response.data.message == "error: \n{\"message\":\"It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile\"}\n" ||
          response.data.message == "error: {\"message\":\"It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile\"}") {
          toast.error("It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile");
        } else {
          toast.error(response.data.message);
        }
      }
    }
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      if (error.response.data.message === "Session has expired" || error.response.data.message === "Unauthorized User" || error.response.data.message === "Invalid Authorization") {
        window.location.href = "/";

        Cookie.remove("prToken")
        Cookie.remove("eToken")
        Cookie.remove("prToken")
        Cookie.remove("saToken")
      }

      if (error.response.data.message === "Invalid token. Please try again.") {
        await refreshToken();
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use((config) => {
  var path = window.location.pathname.split('/');
  const state = store.getState();

  switch (path[1]) {
    case "employer_dashboard":
      let e_token = Cookie.get("eToken");
      if (e_token) config.headers.Authorization = `Bearer ${e_token}`;
      break;

    case "professional":
      let p_token = Cookie.get("pToken");
      if (p_token) config.headers.Authorization = `Bearer ${p_token}`;
      break;

    case "partner_dashboard":
      let pr_token = Cookie.get("prToken");
      if (pr_token) config.headers.Authorization = `Bearer ${pr_token}`;
      break;

    case "super_admin":
      let sa_token = Cookie.get("saToken");
      if (sa_token) config.headers.Authorization = `Bearer ${sa_token}`;
      break;

    default:
      break;
  }

  if (!path[1]) {
    switch (state?.chatBotState?.logout_from) {
      case "employer":
        let e_token = Cookie.get("eToken");
        if (e_token) config.headers.Authorization = `Bearer ${e_token}`;
        break;

      case "professional":
        let p_token = Cookie.get("pToken");
        if (p_token) config.headers.Authorization = `Bearer ${p_token}`;
        break;

      default:
        break;
    }
  }

  if (config.data instanceof FormData) config.headers['Content-Type'] = 'multipart/form-data';
  else config.headers['Content-Type'] = 'application/json';
  return config;
});

export default axiosInstance;

